export const DAILY_USAGE_COLORS = {
  weekdayStart: "#60a5fa",
  weekdayEnd: "#2563eb",
  weekdayHover: "#1d4ed8",
  restDay: "#B96668"
};

export function isCalendarDate(value) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
  const [year, month, day] = value.split("-").map(Number);
  const date = new Date(0);
  date.setUTCFullYear(year, month - 1, day);
  return (
    date.getUTCFullYear() === year &&
    date.getUTCMonth() === month - 1 &&
    date.getUTCDate() === day
  );
}

export function monthsInRange(start, end) {
  if (!isCalendarDate(start) || !isCalendarDate(end) || start > end) return [];
  const months = [];
  let [year, month] = start.split("-").map(Number);
  const last = end.slice(0, 7);
  while (
    year * 12 + month <=
    Number(last.slice(0, 4)) * 12 + Number(last.slice(5))
  ) {
    const key = `${String(year).padStart(4, "0")}-${String(month).padStart(
      2,
      "0"
    )}`;
    if (key > last) break;
    months.push(key);
    if (++month > 12) {
      year++;
      month = 1;
    }
  }
  return months;
}

export function isUsageRestDay(date, holidays = new Set()) {
  if (!isCalendarDate(date)) return false;
  const [year, month, day] = date.split("-").map(Number);
  const calendar = new Date(0);
  calendar.setUTCFullYear(year, month - 1, day);
  const weekday = calendar.getUTCDay();
  return weekday === 0 || weekday === 6 || holidays.has(date);
}

// Both settled results and in-flight requests are shared between modal openings.
export function createHolidayCalendar(fetchMonth, now = Date.now) {
  const cache = new Map();
  const pending = new Map();
  async function monthDates(month) {
    const cached = cache.get(month);
    if (cached && cached.expires > now()) return cached.dates;
    if (pending.has(month)) return pending.get(month);
    const request = Promise.resolve()
      .then(() => fetchMonth(month))
      .then((dates) => {
        if (
          !Array.isArray(dates) ||
          dates.some(
            (date) => !isCalendarDate(date) || !date.startsWith(month + "-")
          )
        )
          throw new Error("Invalid holiday response");
        cache.set(month, { dates, expires: now() + 60 * 60 * 1000 });
        return dates;
      })
      .finally(() => pending.delete(month));
    pending.set(month, request);
    return request;
  }
  return async (start, end) => {
    const months = monthsInRange(start, end);
    const results = await Promise.allSettled(months.map(monthDates));
    return {
      dates: new Set(
        results.flatMap((result) =>
          result.status === "fulfilled" ? result.value : []
        )
      ),
      failed: results.some((result) => result.status === "rejected")
    };
  };
}
